import { DataTableProps, SimplePaginationProps } from '@dixa/lib-shared-habla';
import type {
  SearchConversationEnriched,
  SearchSortField,
} from 'lib-search-types';
import { AsyncStatus } from 'lib-shared-types-api';
import { PropsWithClassName } from 'lib-shared-types-utils';

export type ConversationsTableProps = PropsWithClassName &
  Required<
    Pick<
      DataTableProps<SearchConversationEnriched, never>,
      'selectableRowsProps'
    >
  > & {
    conversations: readonly SearchConversationEnriched[];
    asyncStatus: AsyncStatus;
    paginationProps?: SimplePaginationProps;
  };

export type ConversationsTableSortableField =
  (typeof conversationsTableSortableFields)[number];

export const conversationsTableSortableFields = [
  'created_at',
  'last_message_created_at',
] satisfies SearchSortField<'conversations'>[];
